var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99995 3.59991C8.22086 3.59991 8.39995 3.779 8.39995 3.99991L8.39995 7.8343L10.1684 9.60276C10.3246 9.75896 10.3246 10.0122 10.1684 10.1684C10.0122 10.3247 9.75893 10.3246 9.60272 10.1684L7.7171 8.28282C7.67016 8.23589 7.63733 8.18019 7.6186 8.12099C7.60908 8.091 7.60301 8.05947 7.60084 8.02688C7.6002 8.01726 7.5999 8.00762 7.59995 7.99799",
    fill: "#1F1F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59995 7.99799V3.99991C7.59995 3.779 7.77903 3.59991 7.99995 3.59991",
    fill: "#1F1F1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 14.6666C11.6819 14.6666 14.6667 11.6819 14.6667 7.99998C14.6667 4.31808 11.6819 1.33331 8.00001 1.33331C4.31811 1.33331 1.33334 4.31808 1.33334 7.99998C1.33334 11.6819 4.31811 14.6666 8.00001 14.6666ZM8.00001 13.8666C11.2401 13.8666 13.8667 11.2401 13.8667 7.99998C13.8667 4.75991 11.2401 2.13331 8.00001 2.13331C4.75994 2.13331 2.13334 4.75991 2.13334 7.99998C2.13334 11.2401 4.75994 13.8666 8.00001 13.8666Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.d4170ea81d9b25e44a2afa64d80e905c.svg";
export { ForwardRef as ReactComponent };